/* eslint-disable import/prefer-default-export */

/* eslint-disable indent */

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-23 15:44:25
 * @LastEditTime: 2021-06-11 11:18:55
 * @LastEditors: wangshengqiang
 * @Description: 事件处理
 */
import EvenetHandle from './handleList';

const toArray = (list = []) => {
  return Array.isArray(list) ? list : [list];
};

export const getLocalClick = (events = {}, middlewares = []) => {
  middlewares = toArray(middlewares) || [];

  if (!events) {
    return;
  } // , link = '', modal = '', behavior = '', copyText = '', page = []


  const {
    type = ''
  } = events;

  const localClick = () => {
    if (!EvenetHandle.getHandleByType(type)) throw new Error(`${type}没有对应的处理方法`);
    return EvenetHandle.getHandleByType(type)(events);
  };

  return middlewares.reduceRight((next, middleware) => {
    return middleware(events, next);
  }, localClick);
};